module.exports = __webpack_public_path__ + "static/img/transparent_banner.804e583.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/transparent_banner.png
// module id = 596
// module chunks = 1